export * from './baSidebar.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baSidebar/index.ts